import { toast } from "react-hot-toast";
import {
  COMPLETED_SURVEY,
  GET_QUIZ,
  SUBMIT_QUIZ,
  GET_FAQ,
  AVAILABLE_SURVEY,
  ANSWER_SURVEY,
  ADD_RESPONSE,
  E_MAGAZINE,
  IDEA_BOARD,
  ANNOUNCEMENTS,
  HOF,
  IDEA_BOARD_RESPONSE,
  HOF_RESPONSE,
  ANNOUNCEMENT_RESPONSE,
  SOS,
  VIRTUAL_EVENT,
} from "./constants";
import CommonAPI from "../lib/common";
import { DISCUSSION_BOARD } from "./constants";
import { thubActions } from "./thubSlice";
import { publicActions } from "./publicSlice";

export const getQuiz = (queryString = "") => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${GET_QUIZ}${queryString}`);
      dispatch(thubActions.getQuiz({ response: response }));
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getDiscussion = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonAPI(DISCUSSION_BOARD);
      dispatch(thubActions.getDiscussion({ response: response }));
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      dispatch(publicActions.isLoading(false));

      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const addIdea = (payload) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(IDEA_BOARD, payload, "POST");
      //dispatch(thubActions.getDiscussion({ response: response }));
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getIdeas = (searchQuery) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${IDEA_BOARD}${searchQuery}`);
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getAnnouncements = (searchQuery) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${ANNOUNCEMENTS}${searchQuery}`);
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getHallOfFame = (searchQuery) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${HOF}${searchQuery}`);
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getSOS = (searchQuery) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${SOS}${searchQuery}`);
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const addComment = (moduleType = "ideaBoard", payload) => {
  let endPoint = "";
  switch (moduleType) {
    case "ideaBoard":
      endPoint = IDEA_BOARD_RESPONSE;
      break;
    case "hof":
      endPoint = HOF_RESPONSE;
      break;
    case "announcement":
      endPoint = ANNOUNCEMENT_RESPONSE;
      break;
    default:
      endPoint = "";
  }
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${endPoint}`, payload, "POST");
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const setResponse = (discussionResponse) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(
        ADD_RESPONSE,
        discussionResponse,
        "POST"
      );
      dispatch(thubActions.setResponse({ response: response }));
      toast.success("Comment Successfully Added");
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};
export const addDiscussion = (payload, setActiveTile) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(DISCUSSION_BOARD, payload, "POST");
      toast.success("Discussion Added Successfully");
      setActiveTile("latest");
      return response;
    } catch (error) {
      // console.log(error);
      toast.error("Something went wrong. Please try again.");
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const answerQuiz = (payload, navigate) => {
  // console.log("payload", payload);
  return async (dispatch) => {
    try {
      const response = await CommonAPI(SUBMIT_QUIZ, payload, "POST");
      toast.success("Your answers are successfully submitted");
      return response;
    } catch (error) {
      toast.error("Something went wrong..");
      // console.log(error);
    }
  };
};

//survey

export const getAvailableSurvey = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonAPI(AVAILABLE_SURVEY);
      dispatch(thubActions.getAvailableSurvey({ response: response }));
      dispatch(publicActions.isLoading(false));

      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getCompletedSurvey = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonAPI(COMPLETED_SURVEY);
      dispatch(thubActions.getCompletedSurvey({ response: response }));
      dispatch(publicActions.isLoading(false));

      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const answerSurvey = (payload) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(ANSWER_SURVEY, payload, "POST");
      toast.success("Thank you for participating in our survey.");
      return response;
    } catch (error) {
      toast.error("Something went wrong..");
      // console.log(error);
    }
  };
};

//polls

export const getAvailablePolls = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));

    try {
      const response = await CommonAPI(AVAILABLE_SURVEY);
      dispatch(thubActions.getAvailablePolls({ response: response }));
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      dispatch(publicActions.isLoading(false));
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getCompletedPolls = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonAPI(COMPLETED_SURVEY);
      dispatch(thubActions.getCompletedPolls({ response: response }));
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getFaq = () => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(GET_FAQ);
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getMagazine = (searchQuery) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${E_MAGAZINE}${searchQuery}`);
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const getVirtualEvent = (searchQuery) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${VIRTUAL_EVENT}${searchQuery}`);
      return response;
    } catch (error) {
      // console.log(error);
      if (error.response && error.response.data.message !== "") {
        dispatch(thubActions.alert(error.response.data.message));
      } else {
        dispatch(thubActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};
